var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestBars = function SvgBestBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.811 9.311 11.25 6.75V1.5a.75.75 0 0 0-.75-.75H9a.75.75 0 0 0-.75.75v5.25L5.689 9.311a1.5 1.5 0 0 0-.439 1.06V21.75a1.5 1.5 0 0 0 1.5 1.5h3.75M8.25 4.5h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.75 15.682a3 3 0 0 1-6 0V12h6zm-3 3.068v4.5m2.25 0h-4.5"
  })));
};
export { SvgBestBars as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjgxMSA5LjMxMSAxMS4yNSA2Ljc1VjEuNWEuNzQ5OC43NDk4IDAgMCAwLS43NS0uNzVIOWEuNzUuNzUgMCAwIDAtLjc1Ljc1djUuMjVMNS42ODkgOS4zMTFhMS41IDEuNSAwIDAgMC0uNDM5IDEuMDZWMjEuNzVhMS41MDAxIDEuNTAwMSAwIDAgMCAxLjUgMS41aDMuNzVNOC4yNSA0LjVoMyIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTE4Ljc1IDE1LjY4MmEzIDMgMCAwIDEtNiAwVjEyaDZ2My42ODJaTTE1Ljc1IDE4Ljc1djQuNU0xOCAyMy4yNWgtNC41IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4K";